import React, { useEffect, useRef, useState } from "react";
import { v4 } from "uuid";
import { AiOutlineFile, AiOutlineFolder } from "react-icons/ai";
import { StyledFile, StyledFolder } from "./Tree.style";
import { FolderName } from "./FolderName";
import FILE_ICONS from "./FileIcons";

const PlaceholderInput = ({
  type,
  name,
  folderLevel,
  handleSubmit,
  defaultValue,
  style
}: any) => {
  const [ext, setExt] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const updateExt = (e: any) => {
    let splitted = e.target.value.split(".");
    let ext = splitted && splitted[splitted.length - 1];
    setExt(ext);
  };

  useEffect(() => {
    if (!inputRef.current) return;
    inputRef.current.focus();
    inputRef.current.addEventListener("keypress", (e: any) => {
      if (e.key === "Enter") {
        handleSubmit(e.target.value);
      }
      if (e.key === "Esc") {
        return;
      }
    });
  }, [inputRef, handleSubmit]);

  return type === "file" ? (
    <StyledFile className="tree__file" style={style}>
      {FILE_ICONS[ext as keyof typeof FILE_ICONS] ? FILE_ICONS[ext as keyof typeof FILE_ICONS] : <AiOutlineFile />}
      &nbsp;&nbsp;
      <input
        className="tree__input"
        defaultValue={defaultValue}
        ref={inputRef}
        onChange={updateExt}
      />
    </StyledFile>
  ) : (
    <StyledFolder style={{ ...style, paddingLeft: `${(folderLevel + 1) * 20}px` }}>
      <div className="displayFlex">
        <div className="colorPrimary" style={{ fontSize: "1.2rem" }}>
          <AiOutlineFolder />
        </div>
        &nbsp;&nbsp;
        <input
          ref={inputRef}
          className="tree__input"
          defaultValue={defaultValue}
        />
      </div>
    </StyledFolder>
  );
};

export { PlaceholderInput };
